import React, { Component } from 'react'
import { Media } from 'react-bootstrap'
import * as Cookies from "es-cookie";
import { isBrowser } from "react-device-detect";
import CommonHeader from '../navbars/CommonHeader';
import '../../components/navbars/_navbars.scss'
import './_homeheader.scss'

// Partner institutions whose name is shown in the home header.
const INSTITUTIONS = {
    46: { name: "GITAM JUNIOR COLLEGE", code: "CODE:59425" },
    50: { name: "MEGHA JUNIOR COLLEGE" },
    51: { name: "SAGE ACADEMY" },
    54: { name: "PRAGNA ACADEMY" },
    53: { name: "OMEGA JUNIOR COLLEGE" },
    119: { name: "VIGNAN JUNIOR COLLEGE" },
};

// Header colour follows the selected subject tab (see home/_studenthome.scss).
// Colour classes only: no padding, so the bar is the same height as on every
// other page.
const SUBJECT_CLASSES = {
    Botany: "student-top-nav botany",
    Physics: "student-top-nav physics",
    Chemistry: "student-top-nav",
    Zoology: "student-top-nav zoology",
    Mathematics: "student-top-nav maths",
    Maths: "student-top-nav maths",
    AllSubjects: "student-top-nav AllSubjects",
    Biology: "student-top-nav botany",
};

function InstitutionName({ institution }) {
    if (institution.code) {
        return (
            <div>
                <p className="mb-0">{institution.code}</p>
                <h5 className="mb-0">{institution.name}</h5>
            </div>
        );
    }
    return <h5 className="mb-0 mt-3 ml-2">{institution.name}</h5>;
}

/**
 * Home page header (NEET/JEE home, CBSE, Rapid Revision): the shared
 * CommonHeader bar, coloured by the selected subject (see _studenthome.scss).
 *
 * Props: onClick (sidebar toggle), getSubjects + stateData.mainindex (subject
 * colour), pageType ("CBSE" titles the page CBSE).
 */
class HomeNavbar extends Component {
    subjectClass() {
        const { getSubjects, stateData } = this.props;
        const current = getSubjects && stateData ? getSubjects[stateData.mainindex] : null;
        return (current && SUBJECT_CLASSES[current.subject]) || "student-top-nav";
    }

    render() {
        const examId = Cookies.get("examid");
        const institution = INSTITUTIONS[Cookies.get("institution_id")];

        // State-board exams have no subject colours.
        if (examId == 3 || examId == 6 || examId == 7 || examId == 8) {
            return <CommonHeader color="home" tone="light" onToggleSidebar={this.props.onClick} />;
        }

        // CBSE page, or institute students' exam, as the page title.
        let title = null;
        if (this.props.pageType == "CBSE") title = "CBSE";
        else if (Cookies.get("student_userlevel") == 2) title = examId == 1 ? "NEET" : "JEE (MAINS AND ADVANCED)";

        // freshHeader (student home only): pale header with dark text and the
        // large greeting, instead of the subject gradient (see _homeheader.scss).
        const freshHeader = !!this.props.freshHeader;

        return (
            <CommonHeader
                className={`${this.subjectClass()}${freshHeader ? " home-top-nav" : ""}`}
                tone={freshHeader ? "dark" : "light"}
                onToggleSidebar={this.props.onClick}
                // The fresh header always names the exam, so the bar is never blank.
                title={freshHeader ? (title || Cookies.get("exam_name")) : title}
                left={isBrowser && institution ? (
                    <Media className="college_logo_syles">
                        <Media.Body><InstitutionName institution={institution} /></Media.Body>
                    </Media>
                ) : null}
            />
        );
    }
}

export default HomeNavbar;
